import React, { useState } from 'react'
import { Carousel } from 'react-bootstrap'
import { Link } from 'react-router-dom'

const Hero = () => {
  // State to keep track of the active slide
  const [index, setIndex] = useState(0);

  // Function to handle when a new slide is selected
  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };
  return (
    <section className="hero-section">
      <div className="text-area">
        <div id="hero_section_carousel_container">
          <div
            id="hero_section_text_slider carousel-indicators"
            className="carousel slide"
            data-bs-ride="carousel"
          >
            <Carousel
              className="carousel-inner carousel-dark"
              indicators={true}
              controls={false}
              activeIndex={index}
              onSelect={handleSelect}
            >
              <Carousel.Item className="carousel-item">
                <div>
                  <Carousel.Caption>
                    <h2 className="title-tag">
                      <span className="highlight">Creatyea</span>, your trusted
                      development partner, bringing ideas to life since 2018
                    </h2>
                    <p className="title-sub">
                      We help you make a better generation of the electronics
                      products with a customer-centric approach.
                      <br />
                      <Link className="btn btn-primary" to="/odm_services">
                        ODM Services
                      </Link>
                    </p>
                  </Carousel.Caption>
                </div>
              </Carousel.Item>
              <Carousel.Item className="carousel-item">
                <div>
                  <div>
                    <h2 className="title-tag">
                      Delivering Worldwide Excellence
                    </h2>
                    <p className="title-sub">
                      Trust Creatyea to Ship Your Components Anywhere, Ensuring
                      Global Accessibility for Your Needs.
                      <br />
                      <Link className="btn btn-primary" to="/products">
                        All Products
                      </Link>
                    </p>
                  </div>
                </div>
              </Carousel.Item>
              <Carousel.Item className="carousel-item">
                <div>
                  <div>
                    <h2 className="title-tag">
                      Your Ultimate Component Source
                    </h2>
                    <p className="title-sub">
                      Find Everything You Require in our 2.5M+ Product
                      Catalogue, Simplifying Your Sourcing Journey.
                      <br />
                      <Link className="btn btn-primary" to="/products">
                        All Products
                      </Link>
                    </p>
                  </div>
                </div>
              </Carousel.Item>
              <Carousel.Item className="carousel-item">
                <div>
                  <div>
                    <h2 className="title-tag">
                      Expert Product Development Assistance
                    </h2>
                    <p className="title-sub">
                      Tap into Our Years of Experience to help design and bring
                      your electronic product to market.
                      <br />
                      <Link className="btn btn-primary" to="/odm_services">
                        ODM Services
                      </Link>
                    </p>
                  </div>
                </div>
              </Carousel.Item>
              <Carousel.Item className="carousel-item">
                <div>
                  <div>
                    <h2 className="title-tag">Can't Find a Part?</h2>
                    <p className="title-sub">
                      If you can't find a part of your choice. Request a quote
                      and we will find it for you.
                      <br />
                      <Link
                        className="btn btn-primary"
                        to="/products/get_quote"
                      >
                        Get a Quote
                      </Link>
                    </p>
                  </div>
                </div>
              </Carousel.Item>
              <Carousel.Item className="carousel-item">
                <div>
                  <div>
                    <h2 className="title-tag">
                      Need help with Obsolete Parts?
                    </h2>
                    <p className="title-sub">
                      Our Team of Engineers will Help Find Suitable Alternatives
                      with stable supply chain for the Obsolete Parts in your
                      design.
                      <br />
                      <Link className="btn btn-primary" to="/contact_us">
                        Contact Us
                      </Link>
                    </p>
                  </div>
                </div>
              </Carousel.Item>
              <Carousel.Item className="carousel-item">
                <div>
                  <div>
                    <h2 className="title-tag">
                      Discover China's Largest Electronics Components Collection
                    </h2>
                    <p className="title-sub">
                      Explore a vast array of high-quality components for
                      immediate shipment from China's leading supplier. From
                      semiconductors to sensors, we've got you covered!
                      <br />
                      <Link className="btn btn-primary" to="/contact_us">
                        Contact Us
                      </Link>
                    </p>
                  </div>
                </div>
              </Carousel.Item>
            </Carousel>
          </div>
        </div>
      </div>
      <div className="img-area">&nbsp;</div>
    </section>
  );
}

export default Hero
